<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >{{ aLang.c_create }} phản ánh</span
        >
        <span v-if="mData.viewMode == 'update'"
          >{{ aLang.c_update }} phản ánh</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >{{ aLang.c_detail }} phản ánh</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="4">
              <el-form-item label="Người gửi phản ánh" prop="nguoi_gui_id">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_nguoi_gui"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Số điện thoại" prop="dien_thoai">
                <el-input
                  type="text"
                  v-model="mData.dataForm.dien_thoai"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col
              md="4"
              v-if="
                !['kdl', 'hdv', 'ddat'].includes(mData.loai_nhom_phan_hoi) &&
                !aRole('TourAgent')
              "
            >
              <el-form-item label="Tên đơn vị" prop="ten_don_vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_don_vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="4">
              <el-form-item label="Nhóm phản ánh" prop="nhom_phan_hoi">
                <el-select
                  v-model="mData.dataForm.nhom_phan_hoi"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNhomPhanHoi"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col> -->
          </b-row>

          <b-row>
            <!-- <b-col
              md="4"
              v-if="!['kdl', 'hdv'].includes(mData.loai_nhom_phan_hoi)"
            >
              <el-form-item
                label="Tên đối tượng bị phản ánh"
                prop="ten_doi_tuong_phan_hoi"
              >
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_doi_tuong_phan_hoi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> -->
            <!-- <b-col
              md="4"
              v-if="
                !['kdl', 'hdv', 'ddat'].includes(mData.loai_nhom_phan_hoi) &&
                !aRole('TourAgent')
              "
            >
              <el-form-item label="Tên đơn vị" prop="ten_don_vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_don_vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> -->
            <b-col md="4" v-if="!aRole('TourAgent')">
              <el-form-item label="Phản ánh đến" prop="phan_hoi_den">
                <el-input
                  type="text"
                  v-model="mData.dataForm.phan_hoi_den"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col
              md="4"
              v-if="
                mData.dataForm.doi_tuong_phan_hoi &&
                mData.dataForm.doi_tuong_phan_hoi.doi_tuong == 'DDAT' &&
                mData.viewMode == 'detail' &&
                !['ddat', 'trang_vang'].includes(mData.loai_nhom_phan_hoi)
              "
            >
              <el-form-item
                label="Tên đối tượng nhận phản ánh"
                prop="doi_tuong_phan_hoi.ten_doi_tuong"
              >
                <el-input
                  type="text"
                  v-model="mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong"
                  disabled
                ></el-input>
              </el-form-item>
            </b-col> -->
            <b-col md="4">
              <el-form-item
                label="Thời điểm phản ánh"
                prop="thoi_diem_phan_hoi"
              >
                <el-date-picker
                  type="datetime"
                  v-model="mData.dataForm.thoi_diem_phan_hoi"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  >clearable</el-date-picker
                >
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item
                label="Trạng thái"
                prop="trang_thai"
                v-if="
                  (aRole('Admin') &&
                    mData.dataForm.trang_thai == 'forwarded_to_tcqltt' &&
                    mData.viewMode == 'detail') ||
                  !aRole('Admin')
                "
              >
                <el-select
                  v-model="mData.dataForm.trang_thai"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThai"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="Trạng thái"
                prop="trang_thai"
                v-if="
                  aRole('Admin') &&
                  mData.dataForm.trang_thai != 'forwarded_to_tcqltt' &&
                  mData.viewMode == 'detail'
                "
              >
                <el-select
                  v-model="mData.dataForm.trang_thai"
                  :placeholder="aLang.c_select"
                  clearable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listTrangThai"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="6">
              <b-row>
                <b-col md="12">
                  <el-form-item label="Nội dung" prop="noi_dung">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="mData.dataForm.noi_dung"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item class="mb-0" label="File đính kèm">
                    <b-row>
                      <b-col
                        xl="3"
                        sm="4"
                        cols="6"
                        class="text-center mt-2"
                        v-for="item in mData.fileUploadOption.FileDinhKem
                          .fileList"
                        :key="item.id"
                      >
                        <el-image
                          style="width: 90px; height: 90px"
                          :src="item.url"
                          :preview-src-list="mData.dataDefault.listFileDinhKem"
                          v-if="!fn_checkVideo(item)"
                        >
                          <div slot="error" class="el-image__error">
                            <!-- <i class="el-icon-picture-outline"></i> -->
                            <span class="small" style="line-height: 1rem">{{
                              item.name
                            }}</span>
                          </div>
                        </el-image>
                        <div
                          style="position: relative; cursor: pointer"
                          v-if="fn_checkVideo(item)"
                          @click="fn_playVideo(item)"
                        >
                          <video width="90px" height="90px">
                            <source
                              :src="item.url"
                              :type="fn_changeType(item.extension)"
                            />
                          </video>
                          <div
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              width: 24px;
                              height: 24px;
                              border-radius: 36px;
                              background-color: rgba(80, 67, 67, 0.79);
                              display: flex;
                              align-items: center;
                              border: 1px solid #ffffff;
                            "
                          >
                            <i
                              class="fa fa-play"
                              style="
                                font-size: 14px;
                                color: #ffffff;
                                font-weight: 100;
                                margin-left: 7px;
                              "
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                        <div>
                          <el-button
                            @click="fn_download(item)"
                            type="info"
                            size="small"
                            plain
                            >Tải về</el-button
                          >
                        </div>
                      </b-col>
                    </b-row>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col md="12">
                  <el-form-item label="Địa điểm trên bản đồ" prop>
                    <mapbox-component
                      :viewMode="mData.viewMode"
                      @upmapbox-componentdate="fn_getDataFromMapboxComponent"
                      :cordinatesValue="mData.mapDataObject.value"
                      v-if="mData.dataDefault.showMap"
                      :prop-disabled="mData.viewMode == 'detail'"
                      id="mapBox"
                    ></mapbox-component>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row
            class="mt-3"
            v-if="
              mData.currentUser.roles.includes('Officer') ||
              mData.currentUser.roles.includes('Admin')
            "
          >
            <b-col md="12" class="mb-2">Lịch sử chuyển phản ánh</b-col>
            <div class="col-md-12">
              <el-table
                :data="mData.dataDefault.listLichSu"
                border
                max-height="440"
                style="width: 100%; display: grid"
                :row-class-name="fn_tableRowClassName"
              >
                <el-table-column
                  prop="ten_tu"
                  label="Từ"
                  width="100"
                  title="ten_tu"
                ></el-table-column>
                <el-table-column
                  prop="ten_den"
                  label="Đến"
                  width="100"
                  title="ten_den"
                ></el-table-column>

                <el-table-column prop="ly_do" label="Lý do" min-width="180">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start">
                      <p>{{ scope.row.ly_do | replaceText }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{ scope.row.ly_do | replaceText }}
                      </div>
                    </el-popover>
                    <!-- <el-tooltip class="item" effect="light" :content="scope.row.ly_do" placement="top-start">
                      {{ scope.row.ly_do }}
                    </el-tooltip>-->
                  </template>
                </el-table-column>
                <el-table-column
                  prop="thoi_diem"
                  label="Thời điểm"
                  width="130"
                  align="center"
                  :formatter="fn_formatterDatetime"
                ></el-table-column>
                <el-table-column
                  prop="file_dinh_kem"
                  label="File đính kèm"
                  min-width="250"
                  align="center"
                >
                  <!-- <template slot-scope="scope">
                    <tr
                      v-for="item in scope.row.file_dinh_kem"
                      :key="item"
                      :label="item"
                      :value="item"
                      style="background-color:none;"
                    >
                      <el-link
                        class="cell-child"
                        target="_blank"
                        :href="fn_formatterLink(item)"
                        :underline="false"
                      >{{fn_formatterLinkName(item)}}</el-link>
                    </tr>
                  </template>-->
                  <template slot-scope="scope">
                    <p
                      v-for="item in scope.row.file_dinh_kem"
                      :key="item.id"
                      style="display: inline; width: 100%"
                      class="text-wrap"
                    >
                      <el-link
                        class="cell-child"
                        target="_blank"
                        :href="fn_formatterLink(item)"
                        :underline="false"
                        >{{ fn_formatterLinkName(item) }},</el-link
                      >
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div
      style="
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(80, 67, 67, 0.79);
        top: 0;
        left: 0;
        z-index: 99999;
      "
      v-if="mData.dataDefault.dialogVideo.show"
    >
      <div
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 80%;
          max-height: 80%;
        "
      >
        <video autoplay controls style="max-height: 100vh">
          <source
            :src="mData.dataDefault.dialogVideo.src"
            :type="mData.dataDefault.dialogVideo.type"
          />
        </video>
      </div>
      <div
        style="position: absolute; right: 20px; top: 10px; cursor: pointer"
        @click="fn_closeDialogVideo()"
      >
        <i
          class="fa fa-times"
          style="font-size: 36px; color: #ffffff"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import PhanHoiModel from "./PhanHoiModel";
import mushroom from "../../../service/api/dulich-api";
import MapComponent from "../../../component/MapComponent";
import MapboxComponent from "../../../component/MapboxComponent";

export default {
  components: {
    MapComponent,
    MapboxComponent,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "PhanHoi",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          // listCongTyLuHanh: [],
          listNguoiGuiPhanHoi: [],
          // listTour: [],
          listNhomPhanHoi: [],
          listFileDinhKem: [],
          listDoiTuongPhanHoi: MethodService.copyObject(
            PhanHoiModel.doiTuongPhanHoi
          ),
          trangThai: PhanHoiModel.trangThai,
          trangThaiTcqltt: PhanHoiModel.trangThaiTcqltt,
          listLichSu: [],
          listFileTcqltt: [],
          // listFileId: "",
          listFileId: [],
          listDoiTuong: MethodService.copyObject(PhanHoiModel.doiTuong),
          showMap: false,
          dataForDialog: {},
          allowChange: false,
          listTrangThai: MethodService.copyObject(PhanHoiModel.trangThai),
          dialogVideo: {
            show: false,
            src: "",
            type: "",
          },
        },
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        validForm: PhanHoiModel.validForm,
        fileUploadOption: MethodService.copyObject(
          PhanHoiModel.dataFormOther.fileUploadOption
        ),
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        // coordinatess: [105.75,21],
        dialog: {},
        loai_nhom_phan_hoi: "",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
      },
    };
  },
  filters: {
    replaceText: function (value) {
      if (!value) return "";
      return value.replaceAll(/phản hồi/gi, "phản ánh");
    },
  },
  methods: {
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await mushroom.phan_hoi.findByIdAsync({ id: id, fields: "id,nguoi_gui_id,province_id,thoi_diem_phan_hoi,nhom_phan_hoi,cong_ty_lu_hanh_id,diem_den_an_toan_id,tour_id,doi_tuong_phan_hoi,noi_dung,file_dinh_kem,trang_thai,lich_su,tcqltt.trang_thai,loc" });
      if (res.result) {
        let resData = MethodService.checkDifferentObject(
          MethodService.copyObject(PhanHoiModel.dataForm),
          res.result
        );

        const resKhachDuLichApi = await mushroom.khach_du_lich.findByIdAsync({
          id: resData.nguoi_gui_id,
        });
        if (resKhachDuLichApi.result) {
          if (
            resKhachDuLichApi.result.ho_ten &&
            resKhachDuLichApi.result.ho_ten.ho_ten
          ) {
            resData.ten_nguoi_gui = resKhachDuLichApi.result.ho_ten.ho_ten;
          } else {
            resData.ten_nguoi_gui = "Chưa có thông tin";
          }
          resData.dien_thoai = resKhachDuLichApi.result.dien_thoai;
        } else {
          let resHDV = await mushroom.huong_dan_vien.findByIdAsync({
            id: resData.nguoi_gui_id,
          });
          if (resHDV.result) {
            resData.ten_nguoi_gui = resHDV.result.ho_ten.ho_ten;
            resData.dien_thoai = resHDV.result.dien_thoai;
          }
        }

        if (resData.file_dinh_kem && resData.file_dinh_kem.length > 0) {
          let imageExtension = [
            ".jpg",
            ".jpeg",
            ".png",
            ".gif",
            ".bmp",
            ".tiff",
            ".webp",
            ".svg",
          ];
          let listFile = await mushroom.file.listAsync({
            limit: resData.file_dinh_kem.length,
            filters: "id:in:" + resData.file_dinh_kem.join(","),
          });
          let data = [];
          if (listFile && listFile.result) {
            data = listFile.result;
            data.map((item) => {
              item.url = ExtensionService.urlImg + item.id;
            });

            let imageUrls = listFile.result
              .filter(
                (x) =>
                  typeof x.extension == "string" &&
                  imageExtension.includes(x.extension.toLowerCase())
              )
              .map((a) => a.url);
            this.mData.dataDefault.listFileDinhKem = imageUrls;
          }
          this.mData.fileUploadOption.FileDinhKem.fileList = data;
        }

        if (resData.cong_ty_lu_hanh_id) {
          let resCongTyLuHanhApi = await mushroom.cong_ty_lu_hanh.findByIdAsync(
            { id: resData.cong_ty_lu_hanh_id }
          );
          resData.phan_hoi_den = resCongTyLuHanhApi.result.ten.vi;
        } else {
          resData.phan_hoi_den = "Cơ quan quản lý";
        }
        if (
          res.result &&
          res.result.loc &&
          res.result.loc.coordinates &&
          res.result.loc.coordinates.length >= 2
        ) {
          this.mData.dataPropMapDiaDiem.lat = res.result.loc.coordinates[0];
          this.mData.dataPropMapDiaDiem.lng = res.result.loc.coordinates[1];
          this.mData.dataPropMapDiaDiem.showMap = true;
          if (
            res.result.loc.coordinates[1] == null ||
            res.result.loc.coordinates[0] == null
          ) {
            this.mData.dataDefault.showMap = false;
          } else {
            let coordinate = [
              res.result.loc.coordinates[1],
              res.result.loc.coordinates[0],
            ];
            this.mData.mapDataObject.value = coordinate;
            this.mData.mapDataObject.geoJson.type = "Point";
            this.mData.mapDataObject.geoJson.coordinates = coordinate;
            this.mData.dataDefault.showMap = true;
          }
        }

        if (
          res.result &&
          res.result.tcqltt &&
          res.result.tcqltt.lich_su &&
          res.result.tcqltt.lich_su.length > 0
        ) {
          let resLichSu = res.result.tcqltt.lich_su;

          let tuIds = MethodService.findListItemDifferent(resLichSu, "tu");
          let denIds = MethodService.findListItemDifferent(resLichSu, "den");
          let resTu = await mushroom.user.listAsync({
            filters: "id:in:" + tuIds.join(","),
          });
          let resDen = await mushroom.user.listAsync({
            filters: "id:in:" + denIds.join(","),
          });

          $.each(resLichSu, (index, item) => {
            let nguoiTu = resTu.result.find((element) => {
              return element.id == item.tu;
            });
            if (nguoiTu) {
              item.ten_tu = nguoiTu.account;
            } else {
              item.ten_tu = "";
            }
            let nguoiDen = resDen.result.find((element) => {
              return element.id == item.den;
            });
            if (nguoiDen) {
              item.ten_den = nguoiDen.account;
            } else {
              item.ten_den = "";
            }
            if (item.file_dinh_kem && item.file_dinh_kem.length > 0) {
              this.mData.dataDefault.listFileId =
                this.mData.dataDefault.listFileId.concat(item.file_dinh_kem);
            }
          });
          let listFileIds = this.mData.dataDefault.listFileId;
          let resFiles = await mushroom.file.listAsync({
            filters: "id:in:" + listFileIds.join(","),
          });
          if (resFiles.result) {
            let data = [];
            if (resFiles && resFiles.result) {
              data = resFiles.result;
              data.map((item) => {
                item.url = ExtensionService.urlImg + item.id;
              });
            }
            this.mData.dataDefault.listFileTcqltt = data;
          }
          this.mData.dataDefault.listLichSu = resLichSu;
        }
        // this.mData.loai_nhom_phan_hoi =
        //   this.mData.dataDefault.listNhomPhanHoi.find(
        //     (x) => x.id == resData.nhom_phan_hoi
        //   ).loai;

        if (
          res.result &&
          res.result.doi_tuong_phan_hoi &&
          res.result.doi_tuong_phan_hoi.doi_tuong
        ) {
          try {
            if (this.mData.loai_nhom_phan_hoi == "ddat") {
              if (res.result.doi_tuong_phan_hoi.doi_tuong_id) {
                const response = await mushroom.diem_den_an_toan.findByIdAsync({
                  id: res.result.doi_tuong_phan_hoi.doi_tuong_id,
                });
                res.result.ten_doi_tuong_phan_hoi = response.result
                  ? response.result.thong_tin_chung.ten
                  : "";
              } else {
                res.result.ten_doi_tuong_phan_hoi = "";
              }
            } else {
              switch (res.result.doi_tuong_phan_hoi.doi_tuong) {
                case "DDAT":
                  if (res.result.doi_tuong_phan_hoi.doi_tuong_id) {
                    const donViResponse =
                      await mushroom.diem_den_an_toan.listAsync({
                        filters: `nguoi_tao_id=${res.result.doi_tuong_phan_hoi.doi_tuong_id}`,
                      });
                    res.result.ten_don_vi =
                      donViResponse.result && donViResponse.result.length > 0
                        ? donViResponse.result[0].thong_tin_chung.ten
                        : "";
                  } else {
                    res.result.ten_don_vi = "";
                  }

                  if (res.result.doi_tuong_phan_hoi.doi_tuong_con_id) {
                    const response = await mushroom.tv_dich_vu.findByIdAsync({
                      id: res.result.doi_tuong_phan_hoi.doi_tuong_con_id,
                    });
                    if (response.result) {
                      if (response.result.diem_den) {
                        res.result.ten_doi_tuong_phan_hoi =
                          response.result.diem_den.ten;
                      } else if (response.result.luu_tru) {
                        res.result.ten_doi_tuong_phan_hoi =
                          response.result.luu_tru.ten;
                      } else if (response.result.giai_tri) {
                        res.result.ten_doi_tuong_phan_hoi =
                          response.result.giai_tri.ten;
                      } else if (response.result.am_thuc) {
                        res.result.ten_doi_tuong_phan_hoi =
                          response.result.am_thuc.ten;
                      } else {
                        res.result.ten_doi_tuong_phan_hoi = "";
                      }
                    }
                  } else {
                    res.result.ten_doi_tuong_phan_hoi = "";
                  }
                  break;
                case "DNLH":
                  if (res.result.doi_tuong_phan_hoi.doi_tuong_id) {
                    const donViResponse =
                      await mushroom.cong_ty_lu_hanh.listAsync({
                        filters: `nguoi_quan_ly_ids=${res.result.doi_tuong_phan_hoi.doi_tuong_id}`,
                      });
                    res.result.ten_don_vi =
                      donViResponse.result &&
                      donViResponse.result.length > 0 &&
                      donViResponse.result[0].ten
                        ? donViResponse.result[0].ten.vi
                        : "Chưa có thông tin";
                  } else {
                    res.result.ten_don_vi = "";
                  }

                  if (res.result.doi_tuong_phan_hoi.doi_tuong_con_id) {
                    const response =
                      await mushroom.tv_dich_vu_tour.findByIdAsync({
                        id: res.result.doi_tuong_phan_hoi.doi_tuong_con_id,
                      });
                    res.result.ten_doi_tuong_phan_hoi = response.result
                      ? response.result.ten_tour
                      : "";
                  } else {
                    res.result.ten_doi_tuong_phan_hoi = "";
                  }
                  break;
                default:
                  res.result.ten_doi_tuong_phan_hoi = "";
                  res.result.ten_don_vi = "";
                  break;
              }
            }
          } catch (e) {
            console.error("Có lỗi: %o", e);
          }
        }

        if (
          res.result &&
          res.result.doi_tuong_phan_hoi &&
          res.result.doi_tuong_phan_hoi.doi_tuong &&
          res.result.doi_tuong_phan_hoi.doi_tuong == "DDAT"
        ) {
          if (res.result.doi_tuong_phan_hoi.doi_tuong_id) {
            let resDDAT = await mushroom.diem_den_an_toan.findByIdAsync({
              id: res.result.doi_tuong_phan_hoi.doi_tuong_id,
            });
            if (
              resDDAT.result &&
              resDDAT.result.thong_tin_chung &&
              resDDAT.result.thong_tin_chung.ten
            ) {
              res.result.doi_tuong_phan_hoi.ten_doi_tuong =
                resDDAT.result.thong_tin_chung.ten;
            } else {
              res.result.doi_tuong_phan_hoi.ten_doi_tuong = null;
            }
          } else {
            res.result.doi_tuong_phan_hoi.ten_doi_tuong = null;
          }
        }

        if (
          res.result &&
          res.result.trang_thai &&
          res.result.trang_thai != "forwarded_to_tcqltt" &&
          this.mData.viewMode == "detail" &&
          MethodService.checkRole("Admin")
        ) {
          this.mData.dataDefault.listTrangThai.pop();
        }
        this.mData.dataDefault.dataForDialog = {
          id: id,
          mode: "updateTcqltt",
        };

        this.mData.dataForm = resData;
      }
    },
    async fn_initDataDefault() {
      let data = await mushroom.nhom_phan_hoi.listAsync({ limit: 1000 });
      if (data.result) {
        this.mData.dataDefault.listNhomPhanHoi = data.result;
      }
    },
    fn_tableRowClassName({ row }) {
      if (row.trang_thai == "waiting") {
        return "success-row";
      }
      return "";
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_formatterLink(id) {
      return ExtensionService.urlFile + id;
    },
    fn_formatterLinkName(id) {
      if (this.mData.dataDefault.listFileTcqltt) {
        let resfind = this.mData.dataDefault.listFileTcqltt.find((element) => {
          return element.id == id;
        });
        if (resfind) {
          return decodeURI(resfind.name);
        }
      }
      return "File";
    },

    fn_download(file) {
      window.open(ExtensionService.urlFile + file.id);
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.loc.coordinates[0] = lat;
      this.mData.dataForm.loc.coordinates[1] = lng;
    },

    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },

    fn_checkVideo(item) {
      let extensions = [".mp4", ".webm", ".ogg"];
      if (item.extension && extensions.includes(item.extension)) {
        return true;
      }
      return false;
    },

    fn_changeType(extension) {
      if (extension) {
        return "video/" + extension.replace(".", "");
      }
      return "";
    },

    fn_playVideo(item) {
      this.mData.dataDefault.dialogVideo.src = item.url;
      this.mData.dataDefault.dialogVideo.type = this.fn_changeType(
        item.extension
      );
      this.mData.dataDefault.dialogVideo.show = true;
    },
    fn_closeDialogVideo() {
      this.mData.dataDefault.dialogVideo.src = "";
      this.mData.dataDefault.dialogVideo.type = "";
      this.mData.dataDefault.dialogVideo.show = false;
    },
  },
  created: async function () {
    await this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>
